import { render, staticRenderFns } from "./KartaZiadosti.vue?vue&type=template&id=682245c2&scoped=true&"
import script from "./KartaZiadosti.vue?vue&type=script&lang=js&"
export * from "./KartaZiadosti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682245c2",
  null
  
)

export default component.exports